import React, { useEffect, useRef, useState } from 'react';

const STORAGE_KEY = 'cajero-hotkey-hint-dismissed';

const HOTKEY_LINES = [
  { keys: 'F2', label: 'escáner' },
  { keys: 'Alt+B', label: 'buscar' },
  { keys: 'Alt+C', label: 'cobrar' },
  { keys: 'Alt+N', label: 'nueva venta' },
  { keys: 'Pantalla', label: 'fullscreen' }
];

/**
 * Ayuda discreta de atajos del cajero — popover compacto, no modal.
 */
const CajeroHotkeyHint = ({ compact = false, className = '' }) => {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('touchstart', onPointerDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('touchstart', onPointerDown);
    };
  }, [open]);

  if (dismissed) {
    return null;
  }

  const toggle = () => setOpen((prev) => !prev);

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
    setOpen(false);
  };

  return (
    <div ref={rootRef} className={`relative shrink-0 ${className}`}>
      <button
        type="button"
        onClick={toggle}
        className={`flex items-center justify-center rounded-lg bg-white/10 font-black text-e0e3-accentSoft ring-1 ring-e0e3-accent/25 hover:bg-white/15 ${
          compact ? 'h-9 w-9 text-sm' : 'h-11 w-11 text-base'
        }`}
        title="Atajos de teclado"
        aria-expanded={open}
        aria-haspopup="true"
      >
        ?
      </button>
      {open && (
        <div
          className={`absolute right-0 top-full z-50 mt-1 min-w-[11.5rem] rounded-lg border border-white/10 bg-[#1a1c22]/95 px-2.5 py-2 shadow-lg backdrop-blur-sm ${
            compact ? 'text-[10px]' : 'text-[11px]'
          }`}
          role="tooltip"
        >
          <p className="mb-1.5 font-black uppercase tracking-wide text-e0e3-muted">Atajos</p>
          <ul className="space-y-1 text-white">
            {HOTKEY_LINES.map((line) => (
              <li key={line.keys} className="flex items-baseline gap-2">
                <span className="shrink-0 font-mono font-bold text-e0e3-accentSoft">{line.keys}</span>
                <span className="text-e0e3-muted">·</span>
                <span>{line.label}</span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={handleDismiss}
            className="mt-2 w-full text-left text-[10px] font-semibold text-e0e3-muted hover:text-white"
          >
            No volver a mostrar
          </button>
        </div>
      )}
    </div>
  );
};

export default CajeroHotkeyHint;
